import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '@mdi/font/css/materialdesignicons.css'
Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    font: true,
    icons: 'md'
  },
  theme: {
    themes: {
      dark: false,
      light: {
        primary: '#0D47A1',
        secondary: '#b0bec5',
        accent: '#f5f5f5',
        error: '#FD6B6B',
        cancel: '#757575',
        success: '#46BE8A',
        disabled: '#797979'
      }
    }
  }
})
